// Presentation only. Product identity never grants a module, role or entitlement.
export const PRODUCT_IDENTITIES = {
  bemenu: {
    name: 'BEMENU', workspace: 'Votre espace menus et tables',
    loginSubtitle: 'Vos menus et vos tables, simplement pilotés.',
  },
  becaisse: {
    name: 'BECAISSE', workspace: 'Votre espace commerce',
    loginSubtitle: 'Votre caisse et vos postes, simplement pilotés.',
  },
  bekiosk: {
    name: 'BEKIOSK', workspace: 'Votre espace borne',
    loginSubtitle: 'Votre borne, simplement pilotée.',
  },
  beresto: {
    name: 'BERESTO', workspace: 'Votre espace restaurant',
    loginSubtitle: 'Votre restaurant, simplement piloté.',
  },
};

export const PRODUCT_STORAGE_KEY = 'be.product-identity';
export function storedProduct() {
  try { return sessionStorage.getItem(PRODUCT_STORAGE_KEY); } catch (_) { return null; }
}
export function hasExplicitProduct() {
  try { return sessionStorage.getItem(`${PRODUCT_STORAGE_KEY}.explicit`) === 'true'; } catch (_) { return false; }
}
export function rememberProduct(product, explicit = false) {
  if (!Object.prototype.hasOwnProperty.call(PRODUCT_IDENTITIES, product)) return;
  try {
    if (explicit) sessionStorage.setItem(`${PRODUCT_STORAGE_KEY}.explicit`, 'true');
    else if (storedProduct() !== product) sessionStorage.removeItem(`${PRODUCT_STORAGE_KEY}.explicit`);
    sessionStorage.setItem(PRODUCT_STORAGE_KEY, product);
  } catch (_) { /* Storage is optional. */ }
}
export function productFromSearch(search) {
  const product = new URLSearchParams(search || '').get('product');
  return Object.prototype.hasOwnProperty.call(PRODUCT_IDENTITIES, product) ? product : null;
}
export function brandForPath(path = '', hostname = '') {
  if (/^\/(caisse|pad|cuisine|etat)(\/|$)/i.test(path)) return 'becaisse';
  if (/^\/(c|chat)(\/|$)/i.test(path) || /^\/reservation(\/|$)/i.test(path)) return 'beclick';
  if (/^\/(?:fid|identite\/(?:appareil|bemenu|recuperation))(\/|$)/i.test(path)) return 'befid';
  return /^(www\.)?beclick\.fr$/.test(hostname) ? 'beclick' : 'bekiosk';
}
export function reservationOptionsProduct(location) {
  if (location?.pathname?.replace(/\/+$/, '') !== '/caisse/reservations') return null;
  const params = new URLSearchParams(location.search || '');
  if (params.getAll('from').length !== 1 || params.get('from') !== 'options'
      || params.getAll('product').length !== 1) return null;
  return productFromSearch(location.search);
}
export function kdsOptionsProduct(location) {
  if (location?.pathname?.replace(/\/+$/, '') !== '/cuisine') return null;
  const params = new URLSearchParams(location.search || '');
  if (params.getAll('from').length !== 1 || params.get('from') !== 'options'
      || params.getAll('product').length !== 1) return null;
  return productFromSearch(location.search);
}
export function productForLocation(location, remembered = storedProduct()) {
  const path = location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/admin') {
    const explicit = productFromSearch(location.search);
    if (explicit) return explicit;
    const from = location.state?.from;
    if (from?.pathname && !/^\/admin(?:\/|$)/.test(from.pathname)) return reservationOptionsProduct(from) || kdsOptionsProduct(from) || brandForPath(from.pathname);
    // A direct legacy /admin still opens BEKIOSK; shared screens keep their entry identity.
    return from ? productFromSearch(from.search) || validRemembered(remembered) : 'bekiosk';
  }
  if (/^\/admin\//.test(path)) return productFromSearch(location.search) || validRemembered(remembered);
  return reservationOptionsProduct(location) || kdsOptionsProduct(location) || brandForPath(path);
}
function validRemembered(product) {
  return Object.prototype.hasOwnProperty.call(PRODUCT_IDENTITIES, product) ? product : 'bekiosk';
}
// Shared by the visible login and browser metadata so the domain cannot disagree with the logo.
export function brandForLocation(location, hostname = '') {
  const path = location.pathname === '/admin' ? location.state?.from?.pathname || location.pathname : location.pathname;
  const isAdmin = /^\/admin(?:\/|$)/.test(location.pathname);
  const explicitEntry = Boolean(productFromSearch(location.search) || productFromSearch(location.state?.from?.search));
  const returningToAdmin = isAdmin && (location.pathname !== '/admin' || location.state?.from);
  const keepBeclickDomain = /^(www\.)?beclick\.fr$/.test(hostname)
    && !explicitEntry && !(returningToAdmin && hasExplicitProduct());
  return keepBeclickDomain ? brandForPath(path, hostname) : productForLocation(location);
}
export function loginDestination(location, product) {
  const from = location.state?.from;
  const path = String(from?.pathname || '');
  // Only local route state is accepted, never a URL supplied by a query string.
  if (path.startsWith('/') && !path.startsWith('//') && !path.includes('\\') && !/[\r\n]/.test(path)
      && path.replace(/\/+$/, '') !== '/admin') {
    return `${path}${from?.search || ''}${from?.hash || ''}`;
  }
  if (!Object.prototype.hasOwnProperty.call(PRODUCT_IDENTITIES, product)) return '/admin/select';
  return product === 'becaisse' ? '/caisse' : `/admin/select?product=${product}`;
}
